import React from 'react';
import Panel from 'components/general/panel';
import { SystemText } from 'e4shared';

export const YourBlogs = ({ data, setShow }) => {
    if (!data || data.length === 0) return null;
    const postTotal = data.reduce((a, d) => (a.some(y => y === d.id) ? a : a.concat([d.id])), []).length;

    const message = SystemText(`Home/Widgets/WhatsHappening/BlogPosts/${postTotal === 1 ? 'One' : 'Some'}`, postTotal);

    // const message = `${postTotal} of your blog posts ${postTotal === 1 ? 'has' : 'have'} received some feedback`;

    const url = postTotal === 1 ? `/blog/post/${data[0].id}` : '';

    return <Panel colour="success" icon="comments" message={message} url={url} setShow={setShow} />;
};

export default YourBlogs;
